'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrdersService = function () {
  function OrdersService(Api) {
    "ngInject";

    (0, _classCallCheck3.default)(this, OrdersService);
    this.api = Api;
  }

  (0, _createClass3.default)(OrdersService, [{
    key: 'loadOrders',
    value: function loadOrders(data) {
      var url = '/orders/list';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'getOrder',
    value: function getOrder(id) {
      return this.api.call({
        method: 'get',
        url: '/orders/get/' + id
      });
    }
  }, {
    key: 'getItems',
    value: function getItems(id) {
      return this.api.call({
        method: 'get',
        url: '/orders/items/' + id
      });
    }
  }, {
    key: 'getOrderStatusLogs',
    value: function getOrderStatusLogs(id) {
      return this.api.call({
        method: 'get',
        url: '/orders/statusLogs/' + id
      });
    }
  }, {
    key: 'updateOrderStatus',
    value: function updateOrderStatus(data) {
      var url = '/orders/updateStatus';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'resetOrderStatus',
    value: function resetOrderStatus(id) {
      return this.api.call({
        method: 'get',
        url: '/orders/resetOrderStatus/' + id
      });
    }
  }, {
    key: 'updateInvoiceId',
    value: function updateInvoiceId(data) {
      var url = '/orders/updateInvoiceId';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'getComments',
    value: function getComments(id) {
      return this.api.call({
        method: 'get',
        url: '/orders/comments/' + id
      });
    }
  }, {
    key: 'saveComments',
    value: function saveComments(data) {
      var url = '/orders/saveComment';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'removeComment',
    value: function removeComment(id) {
      var url = '/orders/removeComment/' + id;
      return this.api.call({
        method: 'delete',
        url: url
      });
    }
  }, {
    key: 'sendShippedMail',
    value: function sendShippedMail(id) {
      var url = '/orders/sendShippedMail/' + id;
      return this.api.call({
        method: 'get',
        url: url
      });
    }
  }, {
    key: 'sendInvoiceMail',
    value: function sendInvoiceMail(id) {
      var url = '/orders/sendInvoiceMail/' + id;
      return this.api.call({
        method: 'get',
        url: url
      });
    }
  }, {
    key: 'sendCollectionMail',
    value: function sendCollectionMail(id) {
      var url = '/orders/sendCollectionMail/' + id;
      return this.api.call({
        method: 'get',
        url: url
      });
    }
  }, {
    key: 'sendReceiptMail',
    value: function sendReceiptMail(id) {
      var url = '/orders/sendReceiptMail/' + id;
      return this.api.call({
        method: 'get',
        url: url
      });
    }
  }, {
    key: 'sendReviewMail',
    value: function sendReviewMail(id) {
      var url = '/orders/sendReviewMail/' + id;
      return this.api.call({
        method: 'get',
        url: url
      });
    }
  }, {
    key: 'sendPaperInvoiceMail',
    value: function sendPaperInvoiceMail(id) {
      var url = '/orders/sendPaperInvoiceMail/' + id;
      return this.api.call({
        method: 'get',
        url: url
      });
    }
  }, {
    key: 'sendReminderInvoiceMail',
    value: function sendReminderInvoiceMail(id) {
      var url = '/orders/sendReminderInvoiceMail/' + id;
      return this.api.call({
        method: 'get',
        url: url
      });
    }
  }, {
    key: 'saveShipmentResp',
    value: function saveShipmentResp(data) {
      var url = '/orders/saveShipmentResp';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'tosvg',
    value: function tosvg(data) {
      var url = '/orders/tosvg';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }]);
  return OrdersService;
}();

// WEBPACK FOOTER //


exports.default = OrdersService;


/** WEBPACK FOOTER **
 ** ./client/app/modules/orders/services/order.service.js
 **/